import { RestSlice } from '../../../../../redux/rest.slice';
import { IppReportPackageTemplateElement } from '@rcp/types';
import { Resource, localizationService } from 'src/services';

export const ippAttachmentsSlice = new RestSlice<IppReportPackageTemplateElement>(
	localizationService.getLocalizedString('ipp.reportPackage.reportPackageElements.attachments'),
	Resource.IppReportPackageReportElementTypes
);
export default ippAttachmentsSlice.rests.reducer;
